/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3SubnetsSubnetIdRequest = {
  /**
   * Subnet ID
   */
  subnetId: string;
};

/** @internal */
export const GetApiV3SubnetsSubnetIdRequest$inboundSchema: z.ZodType<
  GetApiV3SubnetsSubnetIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  subnet_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "subnet_id": "subnetId",
  });
});

/** @internal */
export type GetApiV3SubnetsSubnetIdRequest$Outbound = {
  subnet_id: string;
};

/** @internal */
export const GetApiV3SubnetsSubnetIdRequest$outboundSchema: z.ZodType<
  GetApiV3SubnetsSubnetIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3SubnetsSubnetIdRequest
> = z.object({
  subnetId: z.string(),
}).transform((v) => {
  return remap$(v, {
    subnetId: "subnet_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3SubnetsSubnetIdRequest$ {
  /** @deprecated use `GetApiV3SubnetsSubnetIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3SubnetsSubnetIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3SubnetsSubnetIdRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3SubnetsSubnetIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3SubnetsSubnetIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3SubnetsSubnetIdRequest$Outbound;
}

export function getApiV3SubnetsSubnetIdRequestToJSON(
  getApiV3SubnetsSubnetIdRequest: GetApiV3SubnetsSubnetIdRequest,
): string {
  return JSON.stringify(
    GetApiV3SubnetsSubnetIdRequest$outboundSchema.parse(
      getApiV3SubnetsSubnetIdRequest,
    ),
  );
}

export function getApiV3SubnetsSubnetIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3SubnetsSubnetIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3SubnetsSubnetIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3SubnetsSubnetIdRequest' from JSON`,
  );
}
